import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useState } from 'react';

const TripDialog = (props) => {
    var {title, subTitle, options, open, setOpen, onAccept} = props;

    const [errors, setErrors] = useState( { reasonId: undefined});
    const [reason, setReason] = useState(undefined);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = ()=>{
    setOpen(false);
  }
  const handleAccept = () => {
    if(!reason) {
        setErrors({...errors, reasonId:"Reson is required"});
        return;
    }
    if(typeof(onAccept) === 'function')
    {
        onAccept(reason);
        setReason(undefined);
    }
    setOpen(false);
  };

  const reasonSelected= (e)=>{
    setReason(e.target.value);
    if(errors.reasonId){
        setErrors({...errors, reasonId: undefined});
    }
  }
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
           {subTitle}
          </DialogContentText>
          <FormControl fullWidth sx={{mt:2}} error={!!errors?.reasonId}>
            <InputLabel id="reason-label">Reason</InputLabel>
            <Select
              name="reason"
              value={reason || ""}
              label="Reason"
              labelId="reason-label"
              onChange={reasonSelected}
              fullWidth
              error={!!errors?.reasonId}
            >
              {options &&
                options.map((s, index) => {
                  return (
                    <MenuItem key={index} value={s.id}>
                      {s.name}
                    </MenuItem>
                  );
                })}
            </Select>
            <FormHelperText error={!!errors?.reasonId}>{errors?.reasonId}</FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="button" onClick={handleAccept}>{title}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default TripDialog;